module.exports = __webpack_public_path__ + "static/media/background.74930d9c.jpg";